import React, { Component } from 'react';
import Header from './header/header';
import Content from './content/content';
import $ from 'jquery';
import Search from "./content/cate-reports/search/search";



class IndustryReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            count:0
        }
    }
    render() {
        return (
            <div>

            <Header />
                {/*Inside Content Of Report Page*/}
                <section class="ovrfl">
                    <div class="container">
                        <div class="row breadcrumb text-center trght" id="pageHome">
                            <div class="col-md-12">
                                <a href="/">
                                    <span>Home</span>
                                </a>
                                <i class="fa fa-angle-right"></i>
                                <a href="/industry-reports">
                                    <span>Industry Reports</span>
                                </a>
                            </div>
                        </div>


                        <div class="container">
                                {/*<div class="col-xs-12 nope hidden-lg hidden-md hidden-sm">*/}
                                    {/*<a href="https://mordorintelligence.com:81/advanced-search/" class="tlft">Advanced Search111</a>*/}
                                {/*</div>*/}

                            <div class="hidden-lg hidden-sm hidden-md">
                                <div class="container">
                                    <h5 class="">
                                        <a onClick={this.expand.bind(this)}>
                                        <span id="list">
                                            <i class="fa fa-list-ul"></i>
                                        </span>CATEGORIES
                                         <span id="back" class="tright" >
                                            <i class="fa fa-arrow-left"></i>
                                        </span>
                                        </a>
                                    </h5>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12" id="prntt">

                                    <Content location={this.props.location} />

                                </div>


                            </div>




                        </div>




                    </div>
                 </section>
            </div>
        );
    }

    componentDidMount(){
        this.onload();

    }
    onload() {
        function toggleChevron(e) {
            $(e.target)
                .prev('.panel-heading')
                .find("i.indicator")
                .toggleClass('fa-angle-down fa-angle-up');
        }
        $('#accordion').on('hidden.bs.collapse', toggleChevron);
        $('#accordion').on('shown.bs.collapse', toggleChevron);
        $(document).ready(function(e){



            $("#back").fadeOut();
        });
        var count = 0;





    }
      expand(){
        if (this.state.count ==0){
            $("#list").fadeOut(100);
            $('.cate_reports').css("margin-left","260px");
            $('.cate_reports .report_card').css("width",'50%');

            $('.cate_reports').css("margin-right","-260px");

            $('.cate_sidemenu').css("margin-left","0px");



            $("#back").fadeIn(250);
            this.setState({
                count:1
            })

        }
        else{
            $("#back").fadeOut(100);
            $('.cate_reports').css("margin-left","0px");
            $('.cate_reports .report_card').css("width",'100%');
            $('.cate_reports').css("margin-right","0px");
            $('.cate_sidemenu').css("margin-left","-260px");

            $("#list").fadeIn(250);
            this.setState({
                count:0
            })
        }
    }
}


export default IndustryReport;


// WEBPACK FOOTER //
// ./src/industry-reports/industry-reports.js